import { Button, Flex } from "orcs-design-system";

import InboxEmpty from "./InboxEmpty";
import { inboxKind, type InboxItem } from "./registry";

const InboxList = ({
  items,
  selectedKey,
  arrivedKey = null,
  otherCount,
  hasMore,
  loadingMore,
  onSelect,
  onLoadMore,
}: {
  items: InboxItem[];
  selectedKey: string | null;
  /** Key the auto-advance just opened; only that card gets the arrive pulse. */
  arrivedKey?: string | null;
  otherCount: number;
  hasMore: boolean;
  loadingMore: boolean;
  onSelect: (key: string) => void;
  onLoadMore: () => void;
}) => (
  <Flex flexDirection="column" gap="s" width="100%">
    {items.length === 0 && !hasMore ? (
      <InboxEmpty otherCount={otherCount} />
    ) : null}
    <Flex flexDirection="column" gap="xs">
      {items.map((item) => {
        const { Card } = inboxKind(item.kind);
        return (
          <Card
            key={item.key}
            item={item}
            selected={item.key === selectedKey}
            arrived={item.key === arrivedKey}
            onSelect={onSelect}
          />
        );
      })}
    </Flex>
    {hasMore && items.length > 0 ? (
      <Button
        type="button"
        variant="ghost"
        disabled={loadingMore}
        onClick={onLoadMore}
      >
        Load more
      </Button>
    ) : null}
  </Flex>
);

export default InboxList;
